import React from 'react';
import { Duration, Icon1h, Icon2to3h, HalfDay, AllDay, Multiday } from '../Icons/CustomIcons';
import { IconHeader } from './Dialog';

const OPTIONS = [
  { value: 'short', label: 'Weniger als 1 Stunde', icon: <Icon1h size={16} /> },
  { value: 'medium', label: '1–3 Stunden', icon: <Icon2to3h size={16} /> },
  { value: 'halfday', label: 'Halber Tag', icon: <HalfDay size={16} /> },
  { value: 'fullday', label: 'Ganzer Tag', icon: <AllDay size={16} /> },
  { value: 'multiday', label: 'Mehrtägig', icon: <Multiday size={16} /> },
];

/**
 * DurationRange – Filtergruppe für Dauer.
 *
 * Props:
 *   value        – aktuell gewählter Wert ('short' | 'medium' | 'halfday' | 'fullday' | 'multiday' | null)
 *   onChange(v)  – Callback mit neuem Wert; liefert null wenn „Alle" gewählt wird
 *   showAll      – zeigt den „Alle"-Button (Standard: false)
 *   fieldInfo    – optionaler Hilfetext für das FieldInfo-Icon
 *
 * Verwendung Filter:
 *   <DurationRange
 *     value={filters.duration}
 *     onChange={(v) => updateFilter('duration', v)}
 *     showAll
 *   />
 *
 * Verwendung Formular:
 *   <DurationRange
 *     value={formData.duration}
 *     onChange={(v) => setFormData(prev => ({ ...prev, duration: v }))}
 *     fieldInfo={info.duration}
 *   />
 */
export const DurationRange = ({ value, onChange, showAll = false, fieldInfo = '' }) => {
  const displayValue = showAll ? (value ?? 'all') : value;

  const handleClick = (val) => {
    onChange(showAll && val === 'all' ? null : val);
  };

  return (
    <div className="filter">
      <IconHeader Icon={<Duration size={20} color="#fff" />} info={fieldInfo}>
        Dauer
      </IconHeader>
      <div className="filter__box">
        <div className="prop-btn-group">
          {showAll && (
            <button
              type="button"
              className={`prop-btn${displayValue === 'all' ? ' prop-btn--active' : ''}`}
              onClick={() => handleClick('all')}
            >
              Alle
            </button>
          )}
          {OPTIONS.map(({ value: val, label, icon }) => (
            <button
              key={val}
              type="button"
              className={`prop-btn${displayValue === val ? ' prop-btn--active' : ''}`}
              onClick={() => handleClick(val)}
            >
              {icon}{label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
